import React from 'react'
import { RowLayout } from '../RowLayout'
import { translation } from '../../i18n'
import {
  ItemRespType,
  PersonRespType,
  CostRespType,
  CaseCommonDataType,
  CasePLRespType,
  DestinationType,
  AttachmentType,
} from '../../models'
import { priceFormat } from '../../helpers/miscFunctions'
import { strToDateFormat } from '../../helpers'
import { OverviewRowAttachments } from './OverviewRowAttachments'
import { OverviewSectionTitle } from './OverviewSectionTitle'

export type liabilityOverviewRespType = {
  caseCommon?: CaseCommonDataType
  casePL?: CasePLRespType
  destinations: DestinationType[]
  sectionLabelStyles: string
} & translation

export const LiabilityOverview = (params: liabilityOverviewRespType) => {
  const t = params.t
  return (
    <>
      <RowLayout
        text={t('liabilityForm.occurredOn.label')}
        data={strToDateFormat(params.caseCommon?.occurredOn)}
      />
      <RowLayout
        text={t('liabilityForm.destination.label')}
        data={
          params.destinations.find(
            (item: DestinationType) =>
              item.code === params?.caseCommon?.destination
          )?.name
        }
      />
      <RowLayout
        text={t('liabilityForm.resort.label')}
        data={params.caseCommon?.resort}
      />
      <RowLayout
        text={t('liabilityForm.place.label')}
        data={params.caseCommon?.place}
      />
      <RowLayout
        text={t('liabilityForm.damageType.label')}
        data={t(`damageTypes.${params.casePL?.damageType}`)}
      />
      {params.caseCommon?.description !== '' && (
        <RowLayout
          text={t('liabilityForm.description.label')}
          data={params.caseCommon?.description}
        />
      )}
      <RowLayout
        text={t('liabilityForm.assistance.label')}
        // @ts-ignore
        data={params.caseCommon?.assistance ? t('yes') : t('no')}
      />
      {!params.caseCommon?.assistance && (
        <RowLayout
          text={t('liabilityForm.assistanceDesc.label')}
          data={params.caseCommon?.assistanceDesc}
        />
      )}
      {params.casePL?.witnesses && params.casePL?.witnesses?.length > 0 && (
        <OverviewSectionTitle
          styles={params.sectionLabelStyles}
          titleName={t('liabilityForm.witnesses.titleOverview')}
        />
      )}
      {params.casePL?.witnesses &&
        params.casePL?.witnesses?.map((item: PersonRespType, index: number) => {
          return (
            <React.Fragment key={index}>
              <RowLayout
                text={t('liabilityForm.witnesses.firstName.label')}
                data={item.firstName}
              />
              <RowLayout
                text={t('liabilityForm.witnesses.lastName.label')}
                data={item.lastName}
              />
              <RowLayout
                text={t('liabilityForm.witnesses.email.label')}
                data={item.email}
              />
              <RowLayout
                text={t('liabilityForm.witnesses.phone.label')}
                data={item.phone}
              />
              <OverviewRowAttachments
                text={t('attachments.WITNESS.TESTIMONY')}
                attachmentList={item?.attachmentList}
                attachmentType={AttachmentType.TESTIMONY}
              />
            </React.Fragment>
          )
        })}
      {params.casePL?.damageType === 'BODY' &&
        params.casePL?.persons?.map((item: PersonRespType, index: number) => {
          return (
            <React.Fragment key={index}>
              <OverviewSectionTitle
                titleName={t('liabilityForm.persons.title0')}
                styles={params.sectionLabelStyles}
              />
              <RowLayout
                text={t('liabilityForm.persons.firstName.label')}
                data={item.firstName}
              />
              <RowLayout
                text={t('liabilityForm.persons.lastName.label')}
                data={item.lastName}
              />
              <RowLayout
                text={t('liabilityForm.persons.email.label')}
                data={item.email}
              />
              <RowLayout
                text={t('liabilityForm.persons.phone.label')}
                data={item.phone}
              />
              <OverviewRowAttachments
                text={t('attachments.PERSON.PHOTO')}
                attachmentList={item?.attachmentList}
                attachmentType={AttachmentType.PHOTO}
              />
              <OverviewRowAttachments
                text={t('attachments.PERSON.REPORT')}
                attachmentList={item?.attachmentList}
                attachmentType={AttachmentType.REPORT}
              />
            </React.Fragment>
          )
        })}
      {params.casePL?.damageType === 'PROPERTY' &&
        params.casePL?.items?.map((item: ItemRespType, index: number) => {
          return (
            <React.Fragment key={index}>
              <OverviewSectionTitle
                titleName={t('liabilityForm.items.title0')}
                styles={params.sectionLabelStyles}
              />
              <RowLayout
                text={t('liabilityForm.items.description.label')}
                data={item.description}
              />
              <RowLayout
                text={t('liabilityForm.items.ownerName.label')}
                data={item.ownerName}
              />
              <RowLayout
                text={t('liabilityForm.items.ownerContact.label')}
                data={item.ownerContact}
              />
              <RowLayout
                text={t('liabilityForm.items.amount.label')}
                data={priceFormat({
                  price: item.amount,
                  currency: item.currency,
                })}
              />
              <OverviewRowAttachments
                text={t('attachments.ITEMPL.PHOTO')}
                attachmentList={item?.attachmentList}
                attachmentType={AttachmentType.PHOTO}
              />
              <OverviewRowAttachments
                text={t('attachments.ITEMPL.INVOICE')}
                attachmentList={item?.attachmentList}
                attachmentType={AttachmentType.INVOICE}
              />
            </React.Fragment>
          )
        })}
      {params.casePL?.legalExpenses?.costs &&
        params.casePL?.legalExpenses?.costs?.map(
          (item: CostRespType, index: number) => {
            return (
              <React.Fragment key={index}>
                <RowLayout
                  text={t('liabilityForm.amount.label')}
                  data={priceFormat({
                    price: item.amount,
                    currency: item.currency,
                  })}
                />
                <OverviewRowAttachments
                  text={t('attachments.COSTLE.INVOICE')}
                  attachmentList={item?.attachmentList}
                  attachmentType={AttachmentType.INVOICE}
                />
              </React.Fragment>
            )
          }
        )}
    </>
  )
}
